<template>
  <div class="market-wrap">
    <CoinToCoinAccountTitle
      :titles="[this.$t('labels.finance.coinToCoinAcc'), this.$t('labels.finance.records')]"
    ></CoinToCoinAccountTitle>
    <ul class="market-tab" v-if="tabList && tabList.length">
      <li
        v-for="(tab, index) in tabList"
        :key="index"
        :class="{ active: tab.value === currentTab }"
        @click="currentTab = tab.value"
      >
        {{ tab.name }}
      </li>
    </ul>
    <div>
      <DepositTable
        v-if="currentTab === 'recharge'"
        :data="rechargeDataList"
        :coin-id.sync="rechargeCoinId"
        :coin-list="Getter_Assets_List"
        :pagination-config.sync="searchForm"
        @getList="getList"
      />
      <WithdrawTable
        v-else-if="currentTab === 'withdraw'"
        :data="withdrawDataList"
        :coin-id.sync="withdrawCoinId"
        :coin-list="Getter_Assets_List"
        :pagination-config.sync="searchForm"
        @cancelWithdraw="cancelWithdraw"
        @getList="getList"
      />
    </div>
    <TxnPwdModal
      v-if="txnPwdModalShow"
      @submit="cancelWithdraw"
      :show.sync="txnPwdModalShow"
      :title="$t('labels.txnPwd')"
      v-model="txnPwd"
    />
  </div>
</template>
<script>
import GCToCTable from '@/components/GCToCTable';
import TxnPwdModal from '@/components/TxnPwdModal';
import CoinToCoinAccountTitle from '../CoinToCoinAccountTitle';
import { coinToCoinAccountApi } from '@/api/coinToCoinAccount/coinToCoinAccountApi';
import { rechargeApi } from '@/api/coinToCoinAccount/rechargeApi';
import { withDrawApi } from '@/api/coinToCoinAccount/withDrawApi';
import { mapGetters } from 'vuex';
import DepositTable from './DepositTable';
import WithdrawTable from './WithdrawTable';

export default {
  name: 'Banner',
  components: { GCToCTable, CoinToCoinAccountTitle, DepositTable, WithdrawTable, TxnPwdModal },
  data() {
    return {
      currentCoin: 'GRX',
      accounts: [],
      searchForm: {
        current: 1,
        size: 10
      },
      tabList: [
        { name: this.$t('labels.finance.depositRecords'), value: 'recharge' },
        { name: this.$t('labels.finance.withdrawRecords'), value: 'withdraw' }
      ],
      currentTab: 'recharge',
      rechargeCoinId: 1001, // 1001 = BTC
      withdrawCoinId: 1001, // 1001 = BTC
      rechargeColumn: [
        { name: 'created', label: this.$t('labels.date'), align: 'left', field: 'created', sortable: true },
        { name: 'coinName', label: this.$t('labels.finance.coin'), align: 'left', field: 'coinName', sortable: false },
        { name: 'address', label: this.$t('labels.finance.walletAddr'), align: 'left', field: 'address', sortable: false },
        { name: 'amount', label: this.$t('labels.finance.actualAmt'), align: 'left', field: 'amount', sortable: false },
        { name: 'status', label: this.$t('labels.status'), align: 'left', status: 'status', sortable: false }
        // { name: 'operation', label: '操作', align: 'left', field: 'operation', sortable: true },
      ],
      withdrawColumn: [
        { name: 'created', label: this.$t('labels.date'), align: 'left', field: 'created', sortable: true },
        { name: 'coinName', label: this.$t('labels.finance.coin'), align: 'left', field: 'coinName', sortable: false },
        { name: 'toAddress', label: this.$t('labels.finance.walletAddr'), align: 'left', field: 'toAddress', sortable: false },
        { name: 'memo', label: this.$t('labels.finance.memo'), align: 'left', field: 'memo', sortable: false },
        { name: 'volume', label: this.$t('labels.finance.qty'), align: 'left', field: 'volume', sortable: false },
        { name: 'fee', label: this.$t('labels.finance.fee'), align: 'left', field: 'fee', sortable: false },
        { name: 'amount', label: this.$t('labels.finance.actualAmt'), align: 'left', field: 'amount', sortable: false },
        { name: 'status', label: this.$t('labels.status'), align: 'left', status: 'status', sortable: false },
        { name: 'operation', label: this.$t('labels.actions'), align: 'left', field: 'operation', sortable: true }
      ],
      rechargeDataList: {},
      withdrawDataList: {},
      txnPwdModalShow: false,
      txnPwd: '',
      cancelWithdrawLoading: false
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters(['Getter_Assets_List'])
  },
  watch: {
    currentTab() {
      this.getList();
    },
    rechargeCoinId() {
      this.getList();
    },
    withdrawCoinId() {
      this.getList();
    },
    txnPwdModalShow() {
      this.txnPwd = '';
    },
    searchForm(val) {
      this.getList(val);
    }
  },
  methods: {
    getList(data) {
      const func = {
        recharge: rechargeApi,
        withdraw: withDrawApi
      }[this.currentTab];

      const flag = this.currentTab === 'recharge' ? 1 : 2;

      let params = {
        coinId: this.currentTab === 'recharge' ? this.rechargeCoinId : this.withdrawCoinId
      };
      if (data) {
        this.searchForm.current = data.current;
        this.searchForm.size = data.size;
        params.current = data.current;
        params.size = data.size;
      } else {
        params.current = this.searchForm.current;
        params.size = this.searchForm.size;
      }
      func.get(params).then(res => {
        if (flag === 1) {
          this.rechargeDataList = res.data;
        } else {
          this.withdrawDataList = res.data;
        }
      });
    },
    showTxnModal(row) {
      this.txnPwdModalShow = true;
    },
    cancelWithdraw(row) {
      if (this.cancelWithdrawLoading) {
        return;
      }
      withDrawApi
        .cancelWithdrawal(row.id)
        .then(response => {
          this.cancelWithdrawLoading = false;
          if (response.errcode === 0) {
            this.successNotify(this.$t('success.withdraw.cancel'));
            this.getList();
          }
        })
        .catch(error => {
          this.cancelWithdrawLoading = false;
          console.error('error', error);
        });
    }
  }
};
</script>
<style scoped>
.goggle-wrap {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
}
.goggle-wrap > div {
  flex: 0 1 50%;
  padding: 10px 30px;
  line-height: 40px;
  font-size: 16px;
  color: rgba(138, 144, 154, 1);
}
.financial-records-btn {
  cursor: pointer;
}
.financial-records-btn > span {
  position: relative;
  display: block;
}
.financial-records-btn > span.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 6px) rotate(45deg);
  border-top: 1px solid rgba(230, 234, 240, 1);
  border-left: 1px solid rgba(230, 234, 240, 1);
  background-color: #fff;
  width: 10px;
  height: 10px;
}
.market-forms {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 10px;
}
.market-forms input {
  border: 1px solid rgba(230, 234, 240, 1);
  border-radius: 2px;
  padding: 0 10px;
  height: 40px;
  line-height: 20px;
  font-size: 14px;
  color: #333;
}
.market-content {
  margin-top: 40px;
}
.market-wrap {
  margin: 0 auto;
  padding: 0 10px;
  max-width: 1200px;
  width: 100%;
  padding-bottom: 100px;
  min-height: 50vh;
}
.market-tab {
  display: flex;
  background-color: #fff;
  border: 1px solid rgba(230, 234, 240, 1);
  padding-left: 0;
}
.market-tab > li {
  padding: 0 20px;
  font-size: 1rem;
  font-weight: bold;
  line-height: 70px;
  color: #666;
  cursor: pointer;
}
.market-tab > li.active {
  color: #000000;
}
@media screen and (max-width: 599px) {
  .market-tab > li {
    font-size: 0.9rem;
    line-height: 45px;
  }
  .market-wrap::v-deep .market-title {
    font-size: 0.85rem;
  }
}
@media screen and (max-width: 320px) {
  .market-tab > li {
    font-size: 0.77rem;
  }
}
</style>
